"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInScreenshot = HiddenInScreenshot;
exports.Screenshot = Screenshot;
exports.ScreenshotProvider = ScreenshotProvider;
exports.VisibleInScreenshot = VisibleInScreenshot;
exports.useScreenshot = useScreenshot;
exports.useScreenshotContext = useScreenshotContext;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _material = require("@mui/material");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["children"],
  _excluded2 = ["ignoreElements", "onclone"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var screenshotContext = /*#__PURE__*/(0, _react.createContext)();
var hiddenClass = 'cleveron-hidden-in-screenshot';
var visibleClass = 'cleveron-visible-in-screenshot';
function getBackgroundColor(node) {
  if (!node) {
    return null;
  }
  var _getComputedStyle = getComputedStyle(node),
    backgroundColor = _getComputedStyle.backgroundColor;
  var _decomposeColor = (0, _material.decomposeColor)(backgroundColor),
    values = _decomposeColor.values;
  if (values.length === 4 && values[3] === 0) {
    return getBackgroundColor(node.parentElement);
  }
  return backgroundColor;
}
function downloadURL(url, filename) {
  var el = document.createElement('a');
  el.href = url;
  el.download = filename;
  el.click();
  el.remove();
}
function addCSS(css, doc) {
  var el = doc.createElement('style');
  el.textContent = css;
  doc.head.appendChild(el);
}
function renderToImageURL(_x, _x2) {
  return _renderToImageURL.apply(this, arguments);
}
function _renderToImageURL() {
  _renderToImageURL = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(node, _ref2) {
    var bodyStyle,
      id,
      nodeStyle,
      _ref,
      _ignoreElements,
      _onclone,
      options,
      canvas,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          bodyStyle = _ref2.bodyStyle, id = _ref2.id, nodeStyle = _ref2.nodeStyle;
          _ref = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _ignoreElements = _ref.ignoreElements, _onclone = _ref.onclone, options = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
          _context2.next = 5;
          return (0, _html2canvas.default)(node, (0, _extends2.default)({
            backgroundColor: getBackgroundColor(node)
          }, options, {
            ignoreElements: function ignoreElements(el) {
              return el.classList.contains(hiddenClass) || (_ignoreElements == null ? void 0 : _ignoreElements(el));
            },
            onclone: function onclone(doc, el) {
              // Make hidden elements visible
              doc.querySelectorAll(".".concat(visibleClass)).forEach(function (hiddenEl) {
                hiddenEl.classList.remove(visibleClass);
              });

              /* eslint-disable no-param-reassign */
              doc.body.style.minWidth = 'fit-content';
              (0, _extends2.default)(doc.body.style, bodyStyle);
              el.id = id;
              el.style.minWidth = 'fit-content';
              (0, _extends2.default)(el.style, nodeStyle);
              /* eslint-enable no-param-reassign */

              if (_onclone) {
                _onclone(doc, el);
              }
            }
          }));
        case 5:
          canvas = _context2.sent;
          return _context2.abrupt("return", canvas.toDataURL('image/png', 1.0));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _renderToImageURL.apply(this, arguments);
}
var injectedStyles = new Set();
function useCSS(css) {
  // FIXME should be useInsertionEffect in React 18
  (0, _react.useLayoutEffect)(function () {
    if (injectedStyles.has(css)) {
      return;
    }
    addCSS(css, document);
    injectedStyles.add(css);
  });
}
function useScreenshotContext() {
  var screenshot = (0, _react.useContext)(screenshotContext);
  if (!screenshot) {
    throw new Error('useScreenshotContext called outside of context');
  }
  return screenshot;
}

// FIXME replace with React's useId in React 18
var currentId = 0;
function useId() {
  var _useState = (0, _react.useState)(function () {
      currentId += 1;
      return currentId;
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 1),
    id = _useState2[0];
  return "cleveron-id-".concat(id);
}
function useScreenshot(_ref3) {
  var bodyStyle = _ref3.bodyStyle,
    downloadAs = _ref3.downloadAs,
    nodeStyle = _ref3.nodeStyle,
    options = _ref3.options,
    preAction = _ref3.preAction;
  useCSS(".".concat(visibleClass, " { height: 0; overflow: hidden }"));
  var propsRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    propsRef.current = {
      bodyStyle,
      downloadAs,
      nodeStyle,
      options,
      preAction
    };
  }, [downloadAs, options, preAction, bodyStyle, nodeStyle]);
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    onMount = _useState4[0],
    setOnMount = _useState4[1];
  (0, _react.useEffect)(function () {
    if (onMount) {
      onMount();
    }
  }, [onMount]);
  var ref = (0, _react.useRef)();
  var capturingRef = (0, _react.useRef)(false);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    capturing = _useState6[0],
    setCapturing = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    imageURL = _useState8[0],
    setImageURL = _useState8[1];
  var id = useId(); // node id in screenshot

  var capture = (0, _react.useCallback)(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var newImageURL;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!capturingRef.current) {
            _context.next = 2;
            break;
          }
          throw new Error('Capturing already in progress');
        case 2:
          capturingRef.current = true;
          setCapturing(true);
          newImageURL = '';
          _context.prev = 5;
          if (!propsRef.current.preAction) {
            _context.next = 9;
            break;
          }
          _context.next = 9;
          return propsRef.current.preAction();
        case 9:
          _context.next = 11;
          return new Promise(function (resolve) {
            return setOnMount(resolve);
          });
        case 11:
          if (ref.current) {
            _context.next = 13;
            break;
          }
          throw new Error('Ref is unset');
        case 13:
          _context.next = 15;
          return renderToImageURL(ref.current, {
            bodyStyle,
            id,
            nodeStyle
          }, propsRef.current.options);
        case 15:
          newImageURL = _context.sent;
          if (propsRef.current.downloadAs) {
            // Re-render before downloading
            setTimeout(function () {
              return downloadURL(newImageURL, propsRef.current.downloadAs);
            }, 0);
          }
        case 17:
          _context.prev = 17;
          capturingRef.current = false;
          setCapturing(false);
          setImageURL(newImageURL);
          return _context.finish(17);
        case 22:
          return _context.abrupt("return", newImageURL);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5,, 17, 22]]);
  })), []);
  var state = (0, _react.useMemo)(function () {
    return {
      capture,
      capturing,
      id,
      imageURL,
      ref
    };
  }, [capture, capturing, id, imageURL]);
  return state;
}
function ScreenshotProvider(_ref5) {
  var children = _ref5.children,
    screenshot = _ref5.screenshot;
  return /*#__PURE__*/_react.default.createElement(screenshotContext.Provider, {
    value: screenshot
  }, children);
}
function Screenshot(_ref6) {
  var children = _ref6.children,
    props = (0, _objectWithoutProperties2.default)(_ref6, _excluded);
  var screenshot = useScreenshot(props);
  return /*#__PURE__*/_react.default.createElement(ScreenshotProvider, {
    screenshot: screenshot
  }, typeof children === 'function' ? children(screenshot) : children);
}
function ScreenshotAware(_ref7) {
  var children = _ref7.children,
    initialVisible = _ref7.initialVisible,
    unmountOnExit = _ref7.unmountOnExit;
  var _useScreenshotContext = useScreenshotContext(),
    capturing = _useScreenshotContext.capturing;
  if (unmountOnExit && Boolean(initialVisible) === capturing) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: initialVisible ? hiddenClass : visibleClass
  }, children);
}
function VisibleInScreenshot(_ref8) {
  var children = _ref8.children,
    unmountOnExit = _ref8.unmountOnExit;
  return /*#__PURE__*/_react.default.createElement(ScreenshotAware, {
    unmountOnExit: unmountOnExit
  }, children);
}
function HiddenInScreenshot(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/_react.default.createElement(ScreenshotAware, {
    initialVisible: true
  }, children);
}